import { StoreDoc } from '@gooduncles/gu-app-schema';
import { useMemo } from 'react';
import { textSort } from 'src/utils/common';
import { FirebaseManager, WHERE } from 'src/utils/firebase/firebase-manager';
import useSWRImmutable from 'swr/immutable';

const firebaseManager = FirebaseManager.getInstance();
const storePath = 'store';

const getStoresForSearch = (params: [string, WHERE[]]) =>
  firebaseManager.getDocsArrayWithWhere<StoreDoc>(storePath, params[1]);

const useStoresForSearch = (where: WHERE[] = []) => {
  const { data: stores, isValidating } = useSWRImmutable(['getStoresForSearch', where], getStoresForSearch, {
    errorRetryCount: 2,
  });
  const storeSearchValues = useMemo(
    () =>
      stores
        ?.filter((store) => store.storeCode)
        // ?.filter((store) => store.storeCode && storeCodeRegex.test(store.storeCode))
        .sort((a, b) => textSort(a.storeCode ?? '', b.storeCode ?? ''))
        .map((store) => `${store.storeCode}-${store.storeNickname ?? store.storeName}`) ?? null,
    [stores]
  );

  return {
    stores,
    storeSearchValues,
    isValidating,
  };
};

export default useStoresForSearch;
